import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getAllOverallCourseTests } from "../helper/apicalls/overallTest";
import "../styles/MaterialFolder.scss";
import TestIcon from "../assets/png/testIcon.png";
import notAvailable from "../assets/images/notAvalaible.svg";
import GlobalLoader from "../components/GlobalLoader";
import TooltipComponent from "../components/tooltipComponent";

const OverallTest = () => {
  const { coursekey } = useParams();
  const navigate = useNavigate();
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(false);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  useEffect(() => {
    const fetchTests = async () => {
      if (!coursekey) return;

      try {
        setLoading(true);
        const res = await getAllOverallCourseTests({ course_key: coursekey });
        const items = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
            ? res
            : [];
        setTests(items);
      } catch (e) {
        console.error("Failed to load overall tests", e);
        setTests([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTests();
  }, [coursekey]);

  const handleOpenTest = (test) => {
    const id = test.id || test._id;
    if (!id) return;

    if (test.submission && test.submission_id) {
      navigate(
        `/test?overall_test_id=${id}&review=true&submission_id=${test.submission_id}&key=${coursekey}`,
      );
    } else {
      navigate(`/test?overall_test_id=${id}&key=${coursekey}`);
    }
  };

  return (
    <div className="materials-page custom-scrollbar">
      {loading ? (
        <GlobalLoader />
      ) : tests.length === 0 ? (
        <div className="not-found-container">
          <img
            src={notAvailable}
            alt="PowerPoint Icon"
            style={{ width: "300px", height: "300px", marginTop: "4px" }}
          />
          <h3>No Tests Found!</h3>
        </div>
      ) : (
        <div className="practice-test-grid">
          {tests.map((test) => (
            <div
              key={test.id || test._id}
              className="practice-test-card"
              onClick={() => handleOpenTest(test)}
            >
              <div className="practice-test-card__icon">
                <img src={TestIcon} alt="Test" />
              </div>
              <div className="practice-test-card__info">
                <TooltipComponent>
                  {test.name || test.title || "Untitled Test"}
                </TooltipComponent>
              </div>

              <div className="practice-test-card__meta">
                {test.duration && (
                  <div className="meta-item">
                    <span>{test.duration} mins</span>
                  </div>
                )}
                {test.deadline && (
                  <div className="meta-item">
                    <span>Deadline: {formatDate(test.deadline)}</span>
                  </div>
                )}
              </div>

              {test.submission && (
                <div className="completed-tag">Completed</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OverallTest;
